<template>
  <div v-if="currentComp === 'TABLE'" class="h-full flex flex-col">
    <div class="flex mb-10px flex-wrap">
      <el-input
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请输入关键字"
        v-model="searchData.keywords"
        clearable
      ></el-input>
      <el-select
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择区域"
        v-model="searchData.region"
        clearable
      >
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input-number
        controls-position="right"
        size="small"
        class="mr-10px !w-50 mb-10px"
        :min="1"
        v-model="searchData.inspectionCycle"
        placeholder="请选择排查周期"
        :precision="0"
        clearable
      ></el-input-number>
      <el-select
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择排查周期单位"
        v-model="searchData.unitCycle"
        clearable
      >
        <el-option
          v-for="item in unitCycleList"
          :key="item.code"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-select
        v-model="searchData.troubleshootingType"
        size="small"
        class="mr-10px !w-50 mb-10px"
        placeholder="请选择排查类型"
        clearable
      >
        <el-option
          v-for="item in checkTypeList"
          :key="item.value"
          :label="item.displayName"
          :value="Number(item.code)"
        ></el-option>
      </el-select>
      <el-button class="mb-10px" size="small" type="primary" @click="searchList()">搜索</el-button>
      <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
    </div>
    <div class="flex-auto h-0px">
      <el-table
        :data="tableData"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="loading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="作业活动名称"
          width="180"
          prop="jobActivityName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="作业类型"
          width="120"
          prop="jobType"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="作业活动编号"
          width="120"
          prop="jobActivityNumber"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="所属区域" prop="areaStr" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="作业步骤"
          width="180"
          prop="jobSteps"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="排查周期"
          prop="troubleshootingCycle"
          width="120"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.taskSource === 0">{{ scope.row.troubleshootingCycle }}</span>
            <span v-else>/</span>
          </template>
        </el-table-column>
        <el-table-column label="排查类型" prop="inspectionType" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ checkTypeListMap(scope.row.inspectionType) }}
          </template>
        </el-table-column>
        <el-table-column
          label="排查人"
          prop="deadlinePersonName"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="任务开始日期" prop="startTime" show-overflow-tooltip width="180">
          <template slot-scope="scope">
            {{ scope.row.startTime && dayjs(scope.row.startTime).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column label="任务结束日期" prop="endTime" show-overflow-tooltip width="180">
          <template slot-scope="scope">
            {{ scope.row.endTime && dayjs(scope.row.endTime).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column
          label="任务来源"
          prop="taskDetailsTypeStr"
          show-overflow-tooltip
          width="180"
        >
        </el-table-column>
        <el-table-column
          label="超期未排查次数"
          prop="troubleshootingOverdueCount"
          width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" fixed="right" width="70">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="searchList"
        @current-change="findList"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="total"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <OverdueDialog
      type="job"
      :formData="formData"
      @refreshList="findList()"
      v-if="formDialog"
      @cancel="formDialog = false"
    ></OverdueDialog>
  </div>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import { HiddenDangerInvestigationTaskApi } from '@wiz-api/double-prevention-management'
import { UserApi } from '@wiz-api/abp-identity'
import utils from '@/components/safety/enumField/utils'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import OverdueDialog from './OverdueDialog'

const hiddenDangerInvestigationTaskApi = new HiddenDangerInvestigationTaskApi()
const areaApi = new AreaApi()
const userApi = new UserApi()

export default {
  name: 'overdue-task-job-table',
  components: {
    TableOperateButton,
    OverdueDialog,
  },
  data() {
    return {
      formData: {},
      formDialog: false,
      currentRow: null,
      currentComp: 'TABLE',
      userList: [],
      pageNo: 1,
      pageSize: 15,
      areaList: [],
      checkTypeList: [],
      unitCycleList: [],
      // 设备设施清单
      tableData: [],
      loading: false,
      total: 0,
      searchData: {
        keywords: '',
        region: null,
        deadlinePersonId: undefined,
        troubleshootingType: null,
        datePickerValue: [],
        startTime: null,
        endTime: null,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
        ]
      }
    },
    // 排查周期
    unitCycleListMap() {
      return (val) => {
        return (
          this.unitCycleList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    checkTypeListMap() {
      return (val) => {
        return (
          this.checkTypeList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
  },
  created() {
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.UnitCycle',
        'DoublePreventionManagement.DataCategory.CheckType',
      ],
      ['unitCycleList', 'checkTypeList'],
      this
    )
    this.searchList()
    this.getAreaList()
    this.getUserList()
  },
  methods: {
    checkComp(name) {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = name
      })
    },
    // 获取用户列表
    async getUserList() {
      const [err, res] = await userApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.userList = res.items
      }
    },
    // 列表操作-事件 设备设施清单
    handleEvent(row = null, operation) {
      switch (operation) {
        case 'read':
          // 没有新增获取数据
          this.formData = this.$options.data().formData
          this.formData = row
          this.formDialog = true
          break

        default:
          break
      }
    },
    // 搜索 equip 设备设施 job 作业活动
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    resetText() {
      this.searchData = this.$options.data().searchData
      this.searchList()
    },
    async findList() {
      this.loading = true
      this.searchData.startTime =
        this.searchData.datePickerValue && this.searchData.datePickerValue.length === 2
          ? dayjs(this.searchData.datePickerValue[0]).format('YYYY-MM-DD')
          : undefined
      this.searchData.endTime =
        this.searchData.datePickerValue && this.searchData.datePickerValue.length === 2
          ? dayjs(this.searchData.datePickerValue[1]).format('YYYY-MM-DD')
          : undefined
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        isOverdue: true,
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      const [err, res] = await hiddenDangerInvestigationTaskApi.taskJobActivityPagedListQuery(data)
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.loading = false
      }
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
  },
}
</script>

<style></style>
